/* eslint-disable unused-imports/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
/**
 * Generated by orval v7.6.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import type {
  CountryWrapperResource,
  GetReturnCountries500,
  GetReturnCountriesServer500,
} from '@as-react/common-types/delivery-service';
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useCallback } from 'react';

import { queryFetch } from '../../utils/orval/queryFetch';
import { queryKeyMutator } from '../../utils/orval/queryKeyMutator';
import { useQueryFetch } from '../../utils/orval/useQueryFetch';
import type { ErrorType } from '../../utils/orval/useQueryFetch';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Find delivery countries
 */
export const useGetReturnCountriesHook = () => {
  const getReturnCountries = useQueryFetch<CountryWrapperResource>();

  return useCallback(
    (
      mainWebShop: string,
      webShopId: number,
      operationName = 'getReturnCountries',
      options?: SecondParameter<ReturnType<typeof useQueryFetch>>,
      signal?: AbortSignal
    ) => {
      return getReturnCountries(
        { url: `/api/deliverycharges/countries/returnportal/${mainWebShop}/${webShopId}`, method: 'GET', signal },
        { operationName: 'getReturnCountries', ...options }
      );
    },
    [getReturnCountries]
  );
};

export const useGetReturnCountriesQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetReturnCountriesHook>>>,
  TError = ErrorType<GetReturnCountries500>,
>(
  mainWebShop: string,
  webShopId: number,
  operationName = 'getReturnCountries',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReturnCountriesHook>>>, TError, TData>>;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator(
    { mainWebShop, webShopId, operationName },
    { url: `/api/deliverycharges/countries/returnportal/${mainWebShop}/${webShopId}`, queryOptions }
  );

  const getReturnCountries = useGetReturnCountriesHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetReturnCountriesHook>>>> = ({ signal }) =>
    getReturnCountries(mainWebShop, webShopId, operationName, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(mainWebShop && webShopId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetReturnCountriesHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetReturnCountriesQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetReturnCountriesHook>>>
>;
export type GetReturnCountriesQueryError = ErrorType<GetReturnCountries500>;

export function useGetReturnCountries<
  TData = Awaited<ReturnType<ReturnType<typeof useGetReturnCountriesHook>>>,
  TError = ErrorType<GetReturnCountries500>,
>(
  mainWebShop: string,
  webShopId: number,
  operationName: undefined | string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReturnCountriesHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetReturnCountriesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetReturnCountriesHook>>>
        >,
        'initialData'
      >;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReturnCountries<
  TData = Awaited<ReturnType<ReturnType<typeof useGetReturnCountriesHook>>>,
  TError = ErrorType<GetReturnCountries500>,
>(
  mainWebShop: string,
  webShopId: number,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReturnCountriesHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetReturnCountriesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetReturnCountriesHook>>>
        >,
        'initialData'
      >;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReturnCountries<
  TData = Awaited<ReturnType<ReturnType<typeof useGetReturnCountriesHook>>>,
  TError = ErrorType<GetReturnCountries500>,
>(
  mainWebShop: string,
  webShopId: number,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReturnCountriesHook>>>, TError, TData>>;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Find delivery countries
 */

export function useGetReturnCountries<
  TData = Awaited<ReturnType<ReturnType<typeof useGetReturnCountriesHook>>>,
  TError = ErrorType<GetReturnCountries500>,
>(
  mainWebShop: string,
  webShopId: number,
  operationName = 'getReturnCountries',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReturnCountriesHook>>>, TError, TData>>;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useGetReturnCountriesQueryOptions(mainWebShop, webShopId, operationName, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Find delivery countries
 */
export const getReturnCountriesServer = (
  mainWebShop: string,
  webShopId: number,
  operationName = 'getReturnCountries',
  options?: SecondParameter<typeof queryFetch>,
  signal?: AbortSignal
) => {
  return queryFetch<CountryWrapperResource>(
    { url: `/public/deliverycharges/countries/returnportal/${mainWebShop}/${webShopId}`, method: 'GET', signal },
    { operationName: 'getReturnCountries', ...options }
  );
};

export const useGetReturnCountriesServerQueryOptions = <
  TData = Awaited<ReturnType<typeof getReturnCountriesServer>>,
  TError = ErrorType<GetReturnCountriesServer500>,
>(
  mainWebShop: string,
  webShopId: number,
  operationName = 'getReturnCountries',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReturnCountriesServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator(
    { mainWebShop, webShopId, operationName },
    { url: `/public/deliverycharges/countries/returnportal/${mainWebShop}/${webShopId}`, queryOptions }
  );

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReturnCountriesServer>>> = ({ signal }) =>
    getReturnCountriesServer(mainWebShop, webShopId, operationName, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(mainWebShop && webShopId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getReturnCountriesServer>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetReturnCountriesServerQueryResult = NonNullable<Awaited<ReturnType<typeof getReturnCountriesServer>>>;
export type GetReturnCountriesServerQueryError = ErrorType<GetReturnCountriesServer500>;

export function useGetReturnCountriesServer<
  TData = Awaited<ReturnType<typeof getReturnCountriesServer>>,
  TError = ErrorType<GetReturnCountriesServer500>,
>(
  mainWebShop: string,
  webShopId: number,
  operationName: undefined | string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReturnCountriesServer>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReturnCountriesServer>>,
          TError,
          Awaited<ReturnType<typeof getReturnCountriesServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReturnCountriesServer<
  TData = Awaited<ReturnType<typeof getReturnCountriesServer>>,
  TError = ErrorType<GetReturnCountriesServer500>,
>(
  mainWebShop: string,
  webShopId: number,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReturnCountriesServer>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReturnCountriesServer>>,
          TError,
          Awaited<ReturnType<typeof getReturnCountriesServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReturnCountriesServer<
  TData = Awaited<ReturnType<typeof getReturnCountriesServer>>,
  TError = ErrorType<GetReturnCountriesServer500>,
>(
  mainWebShop: string,
  webShopId: number,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReturnCountriesServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Find delivery countries
 */

export function useGetReturnCountriesServer<
  TData = Awaited<ReturnType<typeof getReturnCountriesServer>>,
  TError = ErrorType<GetReturnCountriesServer500>,
>(
  mainWebShop: string,
  webShopId: number,
  operationName = 'getReturnCountries',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReturnCountriesServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useGetReturnCountriesServerQueryOptions(mainWebShop, webShopId, operationName, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
